import { inject } from '@angular/core'
import { Route, Router } from '@angular/router'
import {
    authGuard,
    AuthStateService,
    permissionGuard,
} from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type MarketplaceRoutes = {
    marketplace: Route
    marketplaceDetail: Route
}

export const marketplaceRoutes: MarketplaceRoutes = {
    marketplace: {
        path: 'dashboard/marketplace',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            () => {
                const auth = inject(AuthStateService)
                return auth.getGroupType() !== 'client'
                    ? true
                    : inject(Router).createUrlTree(['/dashboard/home/client'])
            },
            permissionGuard([PERMISSIONS.shop.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./page-marketplace.component').then(
                (m) => m.PageMarketplaceComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    marketplaceDetail: {
        path: 'dashboard/marketplace/:id',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            () => {
                const auth = inject(AuthStateService)
                return auth.getGroupType() !== 'client'
                    ? true
                    : inject(Router).createUrlTree(['/dashboard/home/client'])
            },
            permissionGuard([PERMISSIONS.shop.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-marketplace-detail/page-marketplace-detail.component').then(
                (m) => m.PageMarketplaceDetailComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
}
